import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toggleSidebar } from "../../redux/actions/sidebarActions";
import axiosInstance from "../../axiosInstance";
import useError from "../../hooks/useError";
import { toastr } from "react-redux-toastr";
import {
  Row,
  Col,
  Collapse,
  Navbar,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ListGroup,
  ListGroupItem,
  Form,
  Input,
  Button,
  Spinner,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  Label,
  UncontrolledTooltip,
  Toast,
  ToastBody,
  ToastHeader,
} from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faBellSlash, faBuilding, faClock, faEnvelopeOpen, faComments, faChartPie, faCogs, faCog, faArrowAltCircleRight, faUser, faUserLock, faCross, faTimes, faEnvelope, faBriefcaseMedical, faCarSide, faWrench, faArchive, faRoute, faUserPlus, faClipboardList, faEllipsisH, faChevronUp } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

import useLogout from "../../hooks/useLogout";
import NavbarSearch from "./Search";
import instance from "../../axiosInstance";
import { useProfileContext } from "../../context/profile";

const NavbarDropdown = ({ children, count, header, footer, icon, active, indicator }) => (
  <UncontrolledDropdown nav inNavbar className="ml-lg-1" active={active}>
    <DropdownToggle nav className="nav-icon dropdown-toggle position-relative">
      <FontAwesomeIcon icon={icon} className="align-middle" />
      {indicator ? <span className="indicator" /> : ""}
    </DropdownToggle>
    <DropdownMenu right className="dropdown-menu-lg py-0">
      <div className="dropdown-menu-header position-relative">
        {count} {header}
      </div>
      <ListGroup>{children}</ListGroup>
      {footer != null && (
        <DropdownItem header className="dropdown-menu-footer">
          <span className="text-muted">{footer}</span>
        </DropdownItem>
      )}
    </DropdownMenu>
  </UncontrolledDropdown>
);

const NavbarDropdownItem = ({ icon, dismiss, dismissNotification, note_type, id, notes, reminder_date, is_read, case_id, typeLabel, onSeeMore }) => {
  const label = typeLabel ?? (note_type === "UN" ? "Alert" : "Case");
  const noteText = String(notes || "");
  const isLong = noteText.length > 100;
  const shortText = isLong ? `${noteText.slice(0, 100)}...` : noteText;
  return (
    <ListGroupItem className="position-relative border-0 py-3 px-3">
      <div onClick={() => dismissNotification(note_type, id)} className="text-muted cursor-pointer position-absolute" style={{ top: 8, right: 8 }}>{dismiss}</div>
      <Row noGutters className="align-items-start">
        <Col xs={2} className="pt-1">{icon}</Col>
        <Col xs={10} className="pl-2">
          <div className="d-flex justify-content-between align-items-center mb-1 gap-2">
            <span className="text-muted small text-uppercase fw-semibold" style={{ fontSize: "0.7rem" }}>{label}</span>
            {note_type !== "UN" && case_id && (
              <a
                className="text-primary text-decoration-none fw-semibold"
                href={`/administration/cases/${case_id}/edit`}
                style={{ fontSize: "0.8rem" }}
              >
                NASL-{case_id}
              </a>
            )}
          </div>
          <div className="text-dark mb-1" style={{ fontSize: "0.9rem", lineHeight: 1.4 }}>
            {shortText}
            {isLong && (
              <Button
                color="link"
                size="sm"
                className="p-0 ml-2 text-muted align-baseline"
                style={{ textDecoration: "none" }}
                title="See more"
                onClick={() => onSeeMore?.(noteText)}
              >
                <FontAwesomeIcon icon={faEllipsisH} />
              </Button>
            )}
          </div>
          <div className="text-muted small" style={{ fontSize: "0.75rem" }}>{reminder_date}</div>
        </Col>
      </Row>
    </ListGroupItem>
  );
};

const TaskNavbarDropdownItem = ({ icon, dismiss, onDismiss, task_id, notes, case_id, created_at, onSeeMore }) => {
  const noteText = String(notes || "");
  const isLong = noteText.length > 100;
  const shortText = isLong ? `${noteText.slice(0, 100)}...` : noteText;
  return (
    <ListGroupItem className="position-relative border-0 py-3 px-3">
      <div onClick={() => onDismiss(task_id)} className="text-muted cursor-pointer position-absolute" style={{ top: 8, right: 8 }}>{dismiss}</div>
      <Row noGutters className="align-items-start">
        <Col xs={2} className="pt-1">{icon}</Col>
        <Col xs={10} className="pl-2">
          <div className="d-flex justify-content-between align-items-center mb-1 gap-2">
            <span className="text-muted small text-uppercase fw-semibold" style={{ fontSize: "0.7rem" }}>Task</span>
            {case_id && (
              <a
                className="text-primary text-decoration-none fw-semibold"
                href={`/administration/cases/${case_id}/edit`}
                style={{ fontSize: "0.8rem" }}
              >
                NASL-{case_id}
              </a>
            )}
          </div>
          <div className="text-dark mb-1" style={{ fontSize: "0.9rem", lineHeight: 1.4 }}>
            {shortText}
            {isLong && (
              <Button
                color="link"
                size="sm"
                className="p-0 ml-2 text-muted align-baseline"
                style={{ textDecoration: "none" }}
                title="See more"
                onClick={() => onSeeMore?.(noteText)}
              >
                <FontAwesomeIcon icon={faEllipsisH} />
              </Button>
            )}
          </div>
          <div className="text-muted small" style={{ fontSize: "0.75rem" }}>{created_at}</div>
        </Col>
      </Row>
    </ListGroupItem>
  );
};

const NavbarToggle = connect((store) => ({
  app: store.app,
}))(({ dispatch }) => {
  return (
    <span
      className="sidebar-toggle d-flex mr-2"
      onClick={() => {
        dispatch(toggleSidebar());
      }}
    >
      <i className="hamburger align-self-center" />
    </span>
  );
});

const REMINDER_NOTE_TYPE_COLORS = {
  UN: "#93C5FD",
  "CN-PI": "#6EE7B7",
  "CN-Hire": "#FCD34D",
  "CN-Repair": "#FFD6A5",
  "CN-Storage": "#C4B5FD",
  "CN-Outlay": "#9BDCF7",
  "CN-Recovery": "#FDA4AF",
};
const getReminderNoteTypeColor = (noteType) => REMINDER_NOTE_TYPE_COLORS[noteType] || "#4A90E2";
const getReminderNoteTypeTitle = (noteType) => {
  const titles = { UN: "Alert", "CN-PI": "Personal Injury", "CN-Hire": "Hire", "CN-Repair": "Repair", "CN-Storage": "Storage", "CN-Outlay": "Outlay", "CN-Recovery": "Recovery" };
  return titles[noteType] || noteType;
};

const NavbarDropdowns = connect((store) => ({
  sidebar: store.sidebar,
}))(({ sidebar }) => {
  const { logout } = useLogout();

  const { handleError } = useError();
  const [changePasswordPopupOpen, setChangePasswordPopupOpen] = useState(false);
  const [old_password, setOldPassword] = useState("");
  const [login_password, setNewPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingInterval, setIsFetchingInterval] = useState(false);
  const [isDismissing, setIsdismissing] = useState(false);
  const [isMarkingAllNotifications, setIsMarkingAllNotifications] = useState(false);
  const [new_leads, set_new_leads] = useState(0);
  const [visibleReminderToasts, setVisibleReminderToasts] = useState([]);
  const [reminderToastIndex, setReminderToastIndex] = useState(0);
  const [expandedToastNotes, setExpandedToastNotes] = useState({});
  const [detailsModal, setDetailsModal] = useState({ open: false, title: "Details", text: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (login_password !== confirm_password) {
      toastr.error("Error", "New password and confirm password do not match!");
      return;
    }

    const passwordChangeData = {
      old_password,
      login_password,
      confirm_password,
    };

    try {
      setIsLoading(true);

      const response = await axiosInstance.put("/user/changePassword", passwordChangeData);

      toastr.success("Success", "Password changed successfully");
    } catch (error) {
      handleError(error);
    } finally {
      setChangePasswordPopupOpen(false);
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setIsLoading(false);
    }
  };

  const handleCancle = () => {
    setChangePasswordPopupOpen(false);
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const [notification, set_notifications] = useState(null);
  const [reminders, set_reminders] = useState(null);
  const [tasksUnseenCount, setTasksUnseenCount] = useState(0);
  const [tasksPreview, setTasksPreview] = useState([]);

  const fetchTasksNavbar = async () => {
    try {
      const [countRes, listRes] = await Promise.all([
        instance.get("/user/getTasksCount"),
        instance.get("/user/getTasks", { params: { preview: "1", limit: 10 } }),
      ]);
      setTasksUnseenCount(countRes?.data?.data?.unseen_count ?? 0);
      const list = listRes?.data?.data?.data ?? [];
      setTasksPreview(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error(err);
    }
  };

  const dismissTaskPreview = async (task_id) => {
    try {
      await instance.put("/user/markTaskSeen", { task_id });
      fetchTasksNavbar();
    } catch (err) {
      console.error(err);
    }
  };

  const fetchReminders = async () => {
    try {
      const response = await instance.get("/user/getReminders");
      set_reminders(response?.data?.data ?? []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchReminders();
    fetchTasksNavbar();
    const interval = setInterval(() => {
      fetchReminders();
      fetchTasksNavbar();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setReminderToastIndex(0);
  }, [reminders?.length]);

  useEffect(() => {
    const list = Array.isArray(reminders) ? reminders : [];
    if (reminderToastIndex >= list.length) return;
    const timer = setInterval(() => {
      const idx = reminderToastIndex;
      if (idx >= list.length) return;
      const reminderToAdd = list[idx];
      setVisibleReminderToasts((prev) => [...prev, { ...reminderToAdd, fading: false }]);
      setReminderToastIndex((prev) => prev + 1);
      setTimeout(() => {
        setVisibleReminderToasts((prev) =>
          prev.map((r) => (r.note_type === reminderToAdd.note_type && r.id === reminderToAdd.id ? { ...r, fading: true } : r))
        );
        setTimeout(() => {
          setVisibleReminderToasts((prev) =>
            prev.filter((r) => !(r.note_type === reminderToAdd.note_type && r.id === reminderToAdd.id))
          );
        }, 1000);
      }, 10000);
    }, 2000);
    return () => clearInterval(timer);
  }, [reminderToastIndex, reminders]);

  const dismissReminder = async (note_type, id) => {
    try {
      await instance.put("/user/updateReminder", { note_type, id });
      toastr.success("Reminder dismissed");
      fetchReminders();
    } catch (err) {
      console.error(err);
    }
  };

  const dismissReminderFromToast = (note_type, id) => {
    setVisibleReminderToasts((prev) =>
      prev.map((r) => (r.note_type === note_type && r.id === id ? { ...r, fading: true } : r))
    );
    setTimeout(() => {
      setVisibleReminderToasts((prev) => prev.filter((r) => !(r.note_type === note_type && r.id === id)));
      dismissReminder(note_type, id);
    }, 300);
  };

  const toggleToastNote = (note_type, id) => {
    const key = `${note_type}-${id}`;
    setExpandedToastNotes((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const openDetailsModal = (title, text) => {
    setDetailsModal({ open: true, title: title || "Details", text: text || "-" });
  };

  const closeDetailsModal = () => {
    setDetailsModal({ open: false, title: "Details", text: "" });
  };

  const fetchNotifications = async (isInterval = false) => {
    try {
      if (!isInterval) {
        setIsFetching(true);
      } else {
        setIsFetchingInterval(true);
      }
      const response = await instance.get(`/user/getNotifications`);
      set_notifications(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      if (!isInterval) {
        setIsFetching(false);
      } else {
        setIsFetchingInterval(false);
      }
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(() => fetchNotifications(true), 20000);

    return () => clearInterval(interval);
  }, []);

  const dismissNotification = async (note_type, id) => {
    const body = {
      note_type: note_type,
      id: id,
    };
    try {
      setIsdismissing(true);
      toastr.success("The Notification is Dismissed!");
      await instance.put(`/user/updateNotification`, body);
      fetchNotifications();
    } catch (error) {
      console.log(error);
    } finally {
      setIsdismissing(false);
    }
  };

  const markAllNotificationsRead = async () => {
    try {
      setIsMarkingAllNotifications(true);
      // optimistic UI
      set_notifications([]);
      await instance.put("/user/markAllNotificationsRead");
      fetchNotifications();
    } catch (error) {
      console.log(error);
      fetchNotifications();
    } finally {
      setIsMarkingAllNotifications(false);
    }
  };



  const { profile } = useProfileContext(); // <-- move hook outside
  const permissions = profile?.permission?.caseLead;
  useEffect(() => {

    if (permissions?.lists) {
      (async function () {
        try {
          const { data } = await instance.get("/dashboard/newLeads");
          set_new_leads(data.data);
        } catch (error) {
          handleError(error);
        }
      })();
    }
  }, [permissions]); // Add dependencies if needed


  const leadStyle = {
    marginTop: '16px',
  }
  // Add blinking animation styles
  const blinkStyle = {
    animation: 'blink 1s linear infinite',

  };


  return (
    <>
    <Collapse navbar>
      <Nav className={!sidebar.isOnRight ? "ml-auto" : "mr-auto"} navbar>
        {
          permissions?.lists && (
            <Link to="/administration/caseLead?status=new" className="text-decoration-none" style={leadStyle}>
              <span 
                id="newLeadsTooltip"
                className="fs-16 bg-white px-2 py-1 rounded-pill d-flex align-items-center" 
                style={parseInt(new_leads || 0) > 0 ? blinkStyle : {}}
              >
                <FontAwesomeIcon icon={faUserPlus} className="mr-1" />
                <span className="fs-18 fw-bold">{new_leads || 0}</span>
              </span>
              <UncontrolledTooltip placement="bottom" target="newLeadsTooltip">
                New Leads
              </UncontrolledTooltip>
            </Link>
          )
        }
        <NavbarDropdown header="New Notifications" icon={faBell} count={notification?.length} indicator={!!notification?.length}>
          {!isFetchingInterval && isFetching && (
            <Spinner color="primary" style={{ width: '2rem', height: '2rem' }} />
          )}
          {!!notification?.length && (
            <ListGroupItem className="border-0 py-2 px-3 border-bottom d-flex justify-content-end">
              <Button
                size="sm"
                color="link"
                className="p-0 text-decoration-none"
                disabled={isMarkingAllNotifications}
                onClick={markAllNotificationsRead}
                title="Mark all notifications as read"
              >
                {isMarkingAllNotifications ? (
                  <>
                    <Spinner size="sm" className="mr-2" />
                    Marking…
                  </>
                ) : (
                  "Mark all as read"
                )}
              </Button>
            </ListGroupItem>
          )}
          {notification?.map((item) => {
            let icon = (
              <FontAwesomeIcon icon={faEnvelopeOpen} className="text-warning" />
            );

            if (item.note_type === "UN") {
              icon = <FontAwesomeIcon icon={faBell} />;
            } else if (item.note_type === "CN-PI") {
              icon = <FontAwesomeIcon icon={faBriefcaseMedical} />;
            } else if (item.note_type === "CN-Hire") {
              icon = <FontAwesomeIcon icon={faCarSide} />;
            } else if (item.note_type === "CN-Repair") {
              icon = <FontAwesomeIcon icon={faWrench} />;
            } else if (item.note_type === "CN-Storage") {
              icon = <FontAwesomeIcon icon={faArchive} />;
            } else if (item.note_type === "CN-Recovery") {
              icon = <FontAwesomeIcon icon={faRoute} />;
            } else {
              icon = (
                <FontAwesomeIcon icon={faEnvelope} />
              );
            }

            return (
              <NavbarDropdownItem
                key={item.id}
                typeLabel={getReminderNoteTypeTitle(item.note_type)}
                onSeeMore={(text) => openDetailsModal("Notification Details", text)}
                dismiss={<FontAwesomeIcon icon={faTimes} className="cursor-pointer" />}
                dismissNotification={dismissNotification}
                icon={icon}
                is_read={item.is_read}
                case_id={item.case_id}
                id={item.id}
                note_type={item.note_type}
                notes={item.notes}
                reminder_date={item.reminder_date}
              />
            );
          })}
        </NavbarDropdown>
        <NavbarDropdown header="Reminders" icon={faClock} count={reminders?.length ?? 0} indicator={!!(reminders?.length)} footer={null}>
          {reminders?.map((item) => {
            let icon = <FontAwesomeIcon icon={faClock} className="text-info" />;
            if (item.note_type === "UN") icon = <FontAwesomeIcon icon={faBell} />;
            else if (item.note_type === "CN-PI") icon = <FontAwesomeIcon icon={faBriefcaseMedical} />;
            else if (item.note_type === "CN-Hire") icon = <FontAwesomeIcon icon={faCarSide} />;
            else if (item.note_type === "CN-Repair") icon = <FontAwesomeIcon icon={faWrench} />;
            else if (item.note_type === "CN-Storage") icon = <FontAwesomeIcon icon={faArchive} />;
            else if (item.note_type === "CN-Outlay") icon = <FontAwesomeIcon icon={faClipboardList} />;
            else if (item.note_type === "CN-Recovery") icon = <FontAwesomeIcon icon={faRoute} />;
            return (
              <NavbarDropdownItem
                key={`${item.note_type}-${item.id}`}
                typeLabel={getReminderNoteTypeTitle(item.note_type)}
                onSeeMore={(text) => openDetailsModal("Reminder Details", text)}
                dismiss={<FontAwesomeIcon icon={faTimes} className="cursor-pointer" />}
                dismissNotification={dismissReminder}
                icon={icon}
                case_id={item.case_id}
                id={item.id}
                note_type={item.note_type}
                notes={item.notes}
                reminder_date={item.reminder_date}
              />
            );
          })}
          <DropdownItem tag={Link} to="/reminders" className="text-center border-top">
            View all
          </DropdownItem>
        </NavbarDropdown>
        <NavbarDropdown header="Tasks" icon={faClipboardList} count={tasksUnseenCount} indicator={tasksUnseenCount > 0} footer={null}>
          {tasksPreview?.map((item) => (
            <TaskNavbarDropdownItem
              key={item.task_id}
              icon={<FontAwesomeIcon icon={faClipboardList} className="text-primary" />}
              dismiss={<FontAwesomeIcon icon={faTimes} className="cursor-pointer" />}
              onDismiss={dismissTaskPreview}
              onSeeMore={(text) => openDetailsModal("Task Details", text)}
              task_id={item.task_id}
              notes={item.notes}
              case_id={item.case_id}
              created_at={item.created_at}
            />
          ))}
          <DropdownItem tag={Link} to="/tasks" className="text-center border-top">
            View all
          </DropdownItem>
        </NavbarDropdown>
        <UncontrolledDropdown nav inNavbar className="ml-lg-1">
          <DropdownToggle nav caret>
            <FontAwesomeIcon icon={faCog} className="align-middle" />
          </DropdownToggle>
          <DropdownMenu right>
            <Link to="/profile">
              <DropdownItem>
                <FontAwesomeIcon icon={faUser} fixedWidth className="mr-2 align-middle" />
                View Profile
              </DropdownItem>
            </Link>
            <DropdownItem
              onClick={() => {
                setChangePasswordPopupOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faUserLock} fixedWidth className="mr-2 align-middle" />
              Change Password
            </DropdownItem>

            <Modal isOpen={changePasswordPopupOpen} centered>
              <ModalHeader>Change Password</ModalHeader>
              <Form onSubmit={handleSubmit}>
                <ModalBody className="m-3">
                  <FormGroup>
                    <Col lg={8} sm={12}>
                      <Label for="oldPassword">Old Password</Label>
                      <Input type="password" name="oldPassword" id="oldPassword" value={old_password} onChange={(e) => setOldPassword(e.target.value)} required />
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col lg={8} sm={12}>
                      <Label for="newPassword">New Password</Label>
                      <Input type="password" name="newPassword" id="newPassword" value={login_password} onChange={(e) => setNewPassword(e.target.value)} required />
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col lg={8} sm={12}>
                      <Label for="confirmPassword">Confirm Password</Label>
                      <Input type="password" name="confirmPassword" id="confirmPassword" value={confirm_password} onChange={(e) => setConfirmPassword(e.target.value)} required />
                    </Col>
                  </FormGroup>
                </ModalBody>
                <ModalFooter>
                  <div className="text-center mt-3">
                    <Button color="primary" outline onClick={handleCancle}>
                      <span>Cancel</span>
                    </Button>
                  </div>
                  <div className="text-center mt-3">
                    <Button color="primary" type="submit" disabled={isLoading}>
                      {isLoading && <Spinner size="sm" color="#fff" className="mr-2 mb-1" />}
                      <span>Change Password</span>
                    </Button>
                  </div>
                </ModalFooter>
              </Form>
            </Modal>

            <Modal isOpen={detailsModal.open} toggle={closeDetailsModal} centered size="lg">
              <ModalHeader toggle={closeDetailsModal}>{detailsModal.title}</ModalHeader>
              <ModalBody style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", lineHeight: 1.5 }}>
                {detailsModal.text}
              </ModalBody>
            </Modal>

            <DropdownItem divider />
            <DropdownItem onClick={logout}>
              <FontAwesomeIcon icon={faArrowAltCircleRight} fixedWidth className="mr-2 align-middle" />
              Sign out
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </Nav>
    </Collapse>
    {/* Centralized reminder popups - visible on every page */}
    <div
      className="cc-reminders"
      style={{
        position: "fixed",
        bottom: 10,
        right: 10,
        zIndex: 1050,
        maxHeight: "calc(100vh - 40px)",
        overflowY: "auto",
        paddingRight: 5,
        display: "flex",
        flexDirection: "column",
        pointerEvents: "none",
      }}
    >
      <div style={{ pointerEvents: "auto" }}>
        {visibleReminderToasts.map((reminder) => (
          <Toast
            key={`${reminder.note_type}-${reminder.id}`}
            className={reminder.fading ? "fade-out" : "fade-in"}
            style={{
              marginBottom: 12,
              width: 360,
              background: getReminderNoteTypeColor(reminder.note_type),
              boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
              borderRadius: 10,
              border: "none",
              overflow: "hidden",
            }}
          >
            <ToastHeader
              style={{
                background: "rgba(255, 255, 255, 0.4)",
                color: "#374151",
                borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
                padding: "10px 14px",
              }}
            >
              <div className="d-flex align-items-center justify-content-between w-100 gap-2 w-100 pr-2">
                <span className="text-uppercase fw-semibold" style={{ fontSize: "0.75rem", letterSpacing: "0.02em" }}>
                  {getReminderNoteTypeTitle(reminder.note_type)}
                </span>
                {reminder?.note_type !== "UN" && reminder?.case_id && (
                  <a
                    className="text-primary text-decoration-none fw-semibold flex-shrink-0 ml-auto pl-2 text-right"
                    href={`/administration/cases/${reminder.case_id}/edit`}
                    style={{ fontSize: "0.85rem", minWidth: 98 }}
                  >
                    NASL-{reminder.case_id}
                  </a>
                )}
              </div>
            </ToastHeader>
            <ToastBody style={{ padding: "12px 14px" }}>
              {(() => {
                const key = `${reminder.note_type}-${reminder.id}`;
                const noteText = String(reminder.notes || "");
                const isExpanded = !!expandedToastNotes[key];
                const isLong = noteText.length > 120;
                const shownText = isExpanded || !isLong ? noteText : `${noteText.slice(0, 120)}...`;
                return (
                  <div className="mb-2 text-dark" style={{ fontSize: "0.9rem", lineHeight: 1.4 }}>
                    {shownText}
                    {isLong && (
                      <Button
                        color="link"
                        size="sm"
                        className="p-0 ml-2 align-baseline text-dark"
                        style={{ textDecoration: "none" }}
                        title={isExpanded ? "Show less" : "See more"}
                        onClick={() => toggleToastNote(reminder.note_type, reminder.id)}
                      >
                        <FontAwesomeIcon icon={isExpanded ? faChevronUp : faEllipsisH} />
                      </Button>
                    )}
                  </div>
                );
              })()}
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <small className="text-muted" style={{ fontSize: "0.75rem" }}>{reminder.reminder_date}</small>
                <Button
                  type="button"
                  size="sm"
                  style={{
                    color: "#374151",
                    fontWeight: 600,
                    padding: "5px 12px",
                    borderRadius: 6,
                    border: "1px solid rgba(0,0,0,0.15)",
                    background: "rgba(255, 255, 255, 0.95)",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  }}
                  onClick={() => dismissReminderFromToast(reminder.note_type, reminder.id)}
                >
                  Dismiss
                </Button>
              </div>
            </ToastBody>
          </Toast>
        ))}
      </div>
    </div>
    </>
  );
});

const NavbarComponent = ({ sidebar }) => {

  return (
    <Navbar expand className="navbar-theme">
      {!sidebar.isOnRight ? (
        <React.Fragment>
          <NavbarToggle />
          <NavbarSearch />
          <NavbarDropdowns />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <NavbarDropdowns />
          <NavbarSearch />
          <NavbarToggle />
        </React.Fragment>
      )}
    </Navbar>
  );
};

export default connect((store) => ({
  sidebar: store.sidebar,
}))(NavbarComponent);
